export default {
  女装: "ملابس نسائية",
  男装: "مِلك الرجال",
  手机和小工具: "الهواتف المحمولة والأدوات",
  居家生活: "الحياة المنزلية",
  电脑及周边设备: "أجهزة الكمبيوتر والمعدات الطرفية",
  美容及个人护理: "التجميل والعناية الشخصية",
  家用电器: "الأجهزة المنزلية",
  健康与保健: "الصحة و العافية",
  食品和饮料: "الطعام و الشراب",
  玩具_儿童和婴儿: "الألعاب والأطفال والرضع",
  童装时尚: "أزياء الأطفال",
  视频游戏: "ألعاب الفيديو",
  运动与户外: "الرياضة والهواء الطلق",
  爱好与书籍: "الهوايات والكتب",
  相机和无人机: "الكاميرات والطائرات بدون طيار",
  宠物食品及用品: "أغذية ومستلزمات الحيوانات الأليفة",
  女士包袋: "حقائب نسائية",
  男士包袋: "حقائب رجالية",
  珠宝及配饰: "المجوهرات والاكسسوارات",
  手表: "يشاهد",
  女鞋: "أحذية المرأة",
  男装鞋: "احذية رجالية",
  汽车: "سيارة",
  我附近的ShopeePay: "ShopeePay بالقرب مني",
  餐饮_旅行和服务: "تقديم الطعام والسفر والخدمات",
  旅行及行李: "السفر والأمتعة",
  各种各样的: "أنواع مختلفة",
  我是来买什么的: "ماذا أنا هنا لشراء؟",
  对不起_找不到_相关的商品:
    "عذرًا، لم يتم العثور على أي منتجات متعلقة بـ [{0}].",
  类别: "فئة",
  产品: "منتج",
  店铺: "محل",
  首页: "الصفحة الأمامية",
  限时秒杀: "بيع فلاش لفترة محدودة",
  博客: "مدونة",
  所有品牌: "جميع العلامات التجارية",
  所有类别: "جميع الفئات",
  我的购物车: "سلة التسوق الخاصة بي",
  发货信息: "معلومات التوصيل",
  交货信息: "معلومات التوصيل",
  付款: "قسط",
  确认: "يتأكد",
  您的购物车是空的: "سلة التسوق الخاصة بك فارغة",
  价格: "سعر",
  税: "ضريبة",
  数量: "كمية",
  总计: "المجموع",
  移除: "يزيل",
  返回商店: "العودة إلى المتجر",
  继续发货: "الاستمرار في الشحن",
  筛选: "منقي",
  价格范围: "نطاق السعر",
  排序方式: "ترتيب حسب",
  最新: "حتى الآن",
  最旧: "الأقدم",
  价格从低到高: "السعر من الأقل إلى الأعلى",
  价格从高到低: "السعر من الأعلى إلى الأقل",
  选择交货类型: "اختر نوع التسليم",
  送货上门: "توصيل",
  继续付款: "الاستمرار في الدفع",
  任何其他信息: "أي معلومات أخرى",
  或者: "أو",
  您的钱包余额: "رصيد محفظتك",
  余额不足: "رصيد غير كاف",
  支付: "يدفع",
  我同意: "أنا موافق",
  条款和条件: "الأحكام والشروط",
  退货政策: "سياسة العائدات",
  隐私政策: "سياسة الخصوصية",
  概括: "تعميم",
  项目: "مشروع",
  全部的: "الجميع",
  小计: "المجموع الفرعي",
  总运费: "إجمالي تكلفة الشحن",
  有优惠码吗_在这里输入: "هل يوجد كود خصم؟ أدخل هنا",
  申请: "يتقدم",
  编辑: "يحرر",
  删除: "يمسح",
  添加新地址: "إضافة عنوان جديد",
  继续交货信息: "متابعة معلومات التسليم",
  选择一个地址: "اختر عنوانا",
  购买历史: "تاريخ شراء",
  下载: "تحميل",
  已发送退款请求: "تم إرسال طلب استرداد الأموال",
  对比: "مقارنة",
  对话: "حوار",
  我的钱包: "حقيبتي",
  工单: "أمر العمل",
  管理个人资料: "إدارة الملف الشخصي",
  登出: "خروج",
  重置对比列表: "إعادة تعيين قائمة المقارنة",
  您的对比列表为空: "قائمة المقارنة الخاصة بك فارغة",
  在您的购物车中: "في سلة التسوق الخاصة بك",
  在您的愿望清单中: "في قائمة أمنياتك",
  在您的预定列表中: "في قائمة الحجز الخاصة بك",
  下载您的产品: "قم بتنزيل منتجك",
  选项: "خيارات",
  什么都没找到: "لم يتم العثور على شيء",
  特色产品: "منتجات مميزة",
  最畅销: "الأكثر مبيعًا",
  前_名: "أعلى {0}",
  查看更多: "شاهد المزيد",
  查看所有类别: "عرض كافة الفئات",
  十大品牌: "أفضل عشر علامات تجارية",
  查看所有品牌: "عرض جميع العلامات التجارية",
  登录: "تسجيل الدخول",
  手机号码: "رقم التليفون",
  密码: "كلمة المرور",
  密码长度为6到16个字符: "يتراوح طول كلمة المرور من 6 إلى 16 حرفًا",
  验证码: "رمز التحقق",
  登录中: "تسجيل الدخول",
  游客登录: "تسجيل دخول الزائر",
  注册您的商店: "سجل متجرك",
  现在申请: "قدم الآن",
  成为商家: "كن تاجرا",
  现在注册: "سجل الان",
  登录成功: "هبطت بنجاح",
  通知: "يخطر",
  未找到通知: "لم يتم العثور على الإخطار",
  评论: "تعليق",
  估计运输时间: "وقت الشحن المقدر",
  天: "سماء",
  所售: "مُباع",
  给商家留言: "اترك رسالة للتاجر",
  规格: "تخصيص",
  库存: "في الأوراق المالية",
  总价: "السعر الكلي",
  添加到购物车: "أضف إلى السلة",
  立即购买: "اشتر الآن",
  缺货: "إنتهى من المخزن",
  添加到愿望清单: "أضف إلى قائمة الامنيات",
  加入对比列表: "أضف إلى قائمة المقارنة",
  退款: "استرداد",
  查看条款: "عرض الشروط",
  分享: "يشارك",
  描述: "يصف",
  相关产品: "منتجات ذات صله",
  没有人问过商家: "ولم يسأل أحد التجار",
  该产品暂无评论: "لا توجد آراء حاليا حول هذا المنتج حتى الآن",
  客户评论: "آراء العملاء",
  访问商店: "قم بزيارة المعرض او المتجر",
  畅销产品: "الأكثر مبيعا",
  日期: "تاريخ",
  订单编号: "رقم الأمر",
  总额: "مبلغ مقطوع",
  状态: "ولاية",
  愿望清单: "قائمة الرغبات",
  还没有添加任何东西: "لم تتم إضافة أي شيء حتى الآن",
  注册: "يسجل",
  邀请码: "شفرة الدعوة",
  请输入邀请码: "الرجاء إدخال رمز الدعوة",
  用户名: "اسم المستخدم",
  请输入用户名: "الرجاء إدخال اسم المستخدم",
  用户名长度为6_14个字符: "طول اسم المستخدم هو 6-14 حرفا",
  昵称: "كنية",
  请输入手机号码: "الرجاء إدخال رقم الهاتف",
  手机号码格式错误: "تنسيق خاطئ لرقم الهاتف",
  密码长度为6_16个字符: "طول كلمة المرور هو 6-16 حرفا",
  确认密码: "تأكيد كلمة المرور",
  请输入确认密码: "الرجاء إدخال كلمة المرور التأكيدية",
  提款密码: "كلمة المرور للسحب",
  请输入提款密码: "الرجاء إدخال كلمة المرور للسحب",
  提款密码长度为4_16个字符: "طول كلمة المرور للسحب هو 4-16 حرفًا",
  请输入验证码: "الرجاء إدخال رمز التحقق",
  在_s后发送: "تم الإرسال بعد {0}.",
  发送验证码: "أرسل رمز التحقق",
  注册即表示您同意我们的条款和条件:
    "بالتسجيل فإنك توافق على الشروط والأحكام الخاصة بنا.",
  创建账号: "إنشاء حساب",
  验证码发送成功: "تم إرسال رمز التحقق بنجاح",
  确认密码不一致: "تأكد من أن كلمة المرور غير متناسقة",
  提款密码必须为数字: "يجب أن تكون كلمة مرور السحب رقمية",
  注册成功: "نجاح التسجيل",
  购物车: "عربة التسوق",
  账户: "حساب",
  我的账户: "حسابي",
  已经有一个账户: "هل لديك حساب",
  新地址: "عنوان جديد",
  编辑地址: "تعديل العنوان",
  保存: "يحفظ",
  是否默认: "هل هو الافتراضي",
  具体地址: "عنوان محدد",
  请输入具体地址: "الرجاء إدخال عنوان محدد",
  地区: "منطقة",
  请输入地区: "الرجاء إدخال المنطقة",
  城市: "مدينة",
  请输入城市: "الرجاء إدخال المدينة",
  省份: "مقاطعة",
  请输入省份: "الرجاء إدخال المحافظة",
  邮政编码: "رمز بريدي",
  请输入邮政编码: "الرجاء إدخال الرمز البريدي",
  电话号码: "رقم هاتف",
  请输入电话号码: "يرجى إدخال رقم الهاتف الخاص بك",
  收货人: "المتلقي",
  请输入收货人: "الرجاء إدخال المرسل إليه",
  保存成功: "حفظ بنجاح",
  最畅销的商家: "أفضل التجار مبيعا",
  查看所有的商家: "عرض جميع الشركات",
  支持政策: "سياسة الدعم",
  您的电子邮件地址: "عنوان بريدك  الإلكتروني",
  订阅: "الاشتراك",
  联系方式: "معلومات الاتصال",
  地址: "عنوان",
  美国伊利诺伊州霍夫曼庄园: "هوفمان إستيتس، إلينوي، الولايات المتحدة الأمريكية",
  快速链接: "روابط سريعة",
  商家政策: "سياسات التاجر",
  submit: "يُقدِّم",
  提款银行卡: "سحب البطاقة البنكية",
  我的面板: "لوحتي",
  提示: "تَلمِيح",
  确定登出吗: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
  确定: "بالتأكيد",
  取消: "يلغي",
  项目添加到您的购物车: "أضف السلعة إلى سلة التسوق الخاصة بك",
  经常一起购买: "في كثير من الأحيان شراء معا",
  返回购物: "العودة إلى التسوق",
  进行结算: "الشروع في الخروج",
  帮助热线: "خط المساعدة",
  查看所有通知: "عرض جميع الإخطارات",
  请输入密码: "الرجاء إدخال كلمة المرور",
  前往充值: "اذهب لإعادة الشحن",
  购物车物品: "عناصر عربة التسوق",
  查看购物车: "تحقق من عربة التسوق",
  钱包余额: "رصيد المحفظة",
  充值钱包: "إعادة شحن المحفظة",
  钱包充值_线下_: "إعادة شحن المحفظة (غير متصل)",
  申请提款: "التقدم بطلب للانسحاب",
  钱包收支明细: "تفاصيل دخل المحفظة ونفقاتها",
  批准: "يعتمد",
  提现历史记录: "تاريخ السحب",
  类型: "يكتب",
  信息: "معلومة",
  付款方式: "طريقة الدفع او السداد",
  请选择付款方式: "الرجاء اختيار طريقة الدفع",
  Bill_Type_RECHARGE_BACK: "إعادة شحن الواجهة الخلفية",
  Bill_Type_RECHARGE_ONLINE: "إعادة الشحن عبر الإنترنت",
  Bill_Type_RECHARGE_REGISTER: "سجل مجانا",
  Bill_Type_RECHARGE_JACKPOT: "مكافأة إعادة الشحن",
  Bill_Type_RECHARGE_PRESENT: "إعادة شحن المكافآت",
  Bill_Type_RECHARGE_FROM_COMMISSION: "نقل العمولة",
  Bill_Type_RECHARGE_TG_COMMISSION: "إعادة شحن عمولة الترويج",
  Bill_Type_REGISTER_TG_COMMISSION: "لجنة ترويج التسجيل",
  Bill_Type_WITHDRAW: "ينسحب",
  Bill_Type_WITHDRAW_REJECT: "تم رفض الانسحاب",
  Bill_Type_DEDUCT_HANDLE: "الخصم اليدوي",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "تصحيح التغذية",
  Bill_Type_MINING_PROFIT: "دخل التعدين",
  Bill_Type_MINING_PROFIT_COMMISSION: "لجنة تعزيز دخل التعدين",
  Bill_Type_VIP_UPGRADE: "ترقية VIP",
  Bill_Type_FINANCE_BUY: "شراء المنتجات المالية",
  Bill_Type_FINANCE_CAPITAL_RETURN: "عودة التوازن المالي",
  Bill_Type_FINANCE_FEE: "رسوم الإدارة المالية",
  Bill_Type_FINANCE_PROFIT: "دخل الإدارة المالية",
  Bill_Type_FINANCE_BUY_COMMISSION: "عمولة شراء المنتجات المالية",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "عمولة دخل المنتجات المالية",
  Bill_Type_WHEEL_DRAW: "يانصيب العجلة الكبيرة",
  Bill_Type_BUY: "شراء السلع",
  Bill_Type_PAY_SHOP: "دفع ثمن الشحن",
  Bill_Type_BUY_COMMISSION: "العمولة على العناصر المشتراة",
  Bill_Type_DEPOSIT: "دفع الودائع",
  Bill_Type_STORE_BUY: "شراء السلع",
  Bill_Type_STORE_BUY_REFUND: "استرداد أموال شراء المنتج",
  Bill_Type: "نوع تغيير الحساب",
  Before_Money: "المبلغ السابق",
  Deal_Money: "مبلغ تغيير الحساب",
  After_Money: "المبلغ بعد",
  Bill_Time: "وقت تغيير الحساب",
  No_More_Data: "لا مزيد من البيانات",
  Apply_Money: "مبلغ الطلب",
  Apply_Time: "وقت التطبيق",
  Withdraw_Info: "رسوم المناولة: {fee}، الوصول: {money}",
  提款订单状态_CHECKING: "في انتظار المراجعة",
  提款订单状态_TRANSFERRING: "نقل",
  提款订单状态_PASS: "مؤكد",
  提款订单状态_REJECT: "مرفوض",
  暂无可用充值方式: "لا توجد طريقة لإعادة الشحن متاحة حتى الآن",
  钱包收款码: "رمز الدفع للمحفظة",
  钱包地址: "عنوان المحفظة",
  金额限制: "حد المبلغ",
  复制: "ينسخ",
  付款凭证: "قسيمة دفع",
  收款银行: "البنك المستفيد",
  收款人: "المستفيد",
  收款账号: "رقم حساب الدفع",
  付款银行: "بنك الدفع",
  付款人: "دافع",
  付款账号: "حساب الدفع",
  请输入付款银行: "الرجاء إدخال بنك الدفع",
  请输入付款人: "الرجاء إدخال الدافع",
  请输入付款账号: "الرجاء إدخال رقم حساب الدفع",
  请上传付款凭证: "يرجى تحميل قسيمة الدفع",
  充值金额: "مبلغ إعادة الشحن",
  请输入充值金额: "الرجاء إدخال مبلغ إعادة الشحن",
  submitting: "تقديم...",
  Confirm: "يُقدِّم",
  Commit_Success: "تم الإرسال بنجاح",
  balanceType_BALANCE: "توازن",
  balanceType_COMMISSION: "عمولة",
  Balance: "رصيد الحساب",
  Wash_Money: "إضافة الفسيفساء",
  请选择银行账户: "الرجاء تحديد حساب مصرفي",
  卡号类型: "نوع رقم البطاقة",
  提现金额: "كمية السحب",
  提款金额: "كمية السحب",
  不能为空: "لايمكن ان يكون فارغا",
  金额不正确: "المبلغ غير صحيح",
  please_input_withdraw_password: "الرجاء إدخال كلمة المرور للسحب",
  withdraw_password_format_error:
    "يجب أن تتكون كلمة مرور السحب من 4 إلى 16 حرفًا",
  Fee: "رسوم المعالجة",
  实际到账: "الوصول الفعلي",
  交易币种: "عملة تداولية",
  原始密码: "كلمة المرور الأصلية",
  confirm_password_error: "كلمة المرور التي تم إدخالها مرتين غير صحيحة",
  save_success: "حفظ بنجاح",
  please_input: "تفضل",
  old_password: "كلمة المرور القديمة",
  new_password: "كلمة المرور الجديدة",
  please_input_confirm_password: "الرجاء تأكيد كلمة المرور مرة أخرى",
  没有找到符合条件的商品: "لم يتم العثور على منتجات مطابقة",
  Search: "يبحث",
  全部: "الجميع",
  EnumGoodsOrderState_USER_PAY: "إنتظار التسليم",
  EnumGoodsOrderState_SHOP_PAY: "تسليم",
  EnumGoodsOrderState_SUCCESS: "ينهي",
  EnumGoodsOrderState_CANCEL: "ألغيت",
  EnumGoodsOrderState_REFUND_SUCCESS: "ردها",
  订单号: "رقم الأمر",
  用户名称: "اسم المستخدم",
  收益: "دخل",
  支付时间: "وقت الدفع",
  配送时间: "موعد التسليم",
  完成时间: "الوقت الكامل",
  发货: "سفينة",
  全选: "اختر الكل",
  物品已添加到愿望清单: "تمت إضافة العنصر إلى قائمة الرغبات",
  物品已添加到比较列表: "تمت إضافة العنصر إلى قائمة المقارنة",
  购买成功提示: "تهانينا، عملية الشراء ناجحة",
  订单列表: "لائحة الطلبات",
  商品名: "اسم المنتج",
  图片: "صورة",
  没有品牌: "أي علامة تجارية",
  基本信息: "معلومات اساسية",
  Account_Name: "اسم فتح الحساب",
  Bank_Account: "حساب البنك",
  Bank_Phone: "حجز رقم الهاتف المحمول",
  IFSC: "حساب إفسك",
  UPI: "حساب يو بي آي",
  PIX: "حساب بيكس",
  CPF: "حساب CPF",
  GCASH: "حساب جي كاش",
  POWWI: "حساب بووي",
  身份证号: "رقم الهوية",
  Edit: "يراجع",
  Delete: "يمسح",
  Add: "جديد",
  Forget_Withdraw_Password: "نسيت كلمة المرور للسحب",
  Bank_Card_Info: "معلومات البطاقة المصرفية",
  收款人地址: "عنوان المستفيد",
  SWIFT: "سويفت",
  Bank_Branch: "اسم الفرع",
  分行代码: "رمز الفرع",
  银行地址: "عنوان البنك",
  Email: "بريد إلكتروني",
  银行卡长度必须超过: "يجب أن يتجاوز طول البطاقة المصرفية {length}",
  银行卡格式不正确: "تنسيق البطاقة المصرفية غير صحيح",
  Do_you_confirm_delete: "تأكيد الحذف؟",
  Please_Login_First: "الرجاء تسجيل الدخول أولا",
  Bank_Name: "اسم البنك",
  Please_add_bank_first: "لم تقم بربط بطاقتك المصرفية بعد، يرجى إضافتها أولاً",
  withdrawType: "نوع السحب",
  withdraw_money_limit:
    "يجب أن يكون مبلغ السحب أكبر من 0 وأقل من أو يساوي {الرصيد}",
  withdraw_times_limit:
    "لقد قمت بالسحب {todayWithdrawNum} مرات اليوم، وسيتم فرض رسوم معالجة قدرها {withdrawFee}% بعد {limitTimes} مرات. هل أنت متأكد من الانسحاب؟",
  Copy_Success: "تم النسخ بنجاح",
  商店首页: "الصفحة الرئيسية للمتجر",
  所有产品: "جميع المنتجات",
  新到货产品: "المنتجات التي وصلت حديثا",
  所有商家: "جميع التجار",
  请上传: "يرجى التحميل",
  请输入: "تفضل",
  忘记密码: "ننسى كلمة المرور",
  记得我: "تذكرنى",
  共_件: "إجمالي {0} عنصر",
  取消订单: "الغاء الطلب",
  申请退款: "طلب استرداد",
  未知商家: "تاجر غير معروف",
  到账: "إيصال",
  提款订单状态: "حالة أمر السحب",
  前_名类别: "أهم {0} فئات",
  取消订单原因_不想要了: "لا تريد ذلك بعد الآن",
  取消订单原因_商品错选_多选: "اختيار منتج خاطئ/تحديدات متعددة",
  取消订单原因_商品无货: "المنتج خارج المخزون",
  取消订单原因_地址信息填写错误: "تم ملء معلومات العنوان بشكل غير صحيح",
  取消订单原因_商品降价: "تخفيض سعر المنتج",
  取消订单原因_价格高于其他平台: "السعر أعلى من المنصات الأخرى",
  取消订单原因_没用_少用_错用优惠:
    "عدم الاستفادة / التقليل من استخدام / إساءة استخدام الخصومات",
  退款原因_拍错_多拍_不喜欢: "لقطة خاطئة / لقطة إضافية / لا تعجبني",
  退款原因_商品成分描述不符: "وصف مكونات المنتج غير متطابق",
  退款原因_与商家协商一致退款: "استرداد المبلغ على النحو المتفق عليه مع التاجر",
  退款原因_生产日期_保质期与商品描述不符:
    "تاريخ الإنتاج/مدة الصلاحية لا يتطابق مع وصف المنتج",
  退款原因_图片_产地_批号_规格等描述不符:
    "الصور/أصل المنشأ/رقم الدفعة/المواصفات والأوصاف الأخرى غير متطابقة",
  退款原因_质量问题: "قضايا الجودة",
  退款原因_商品变质_发霉_有异物: "المنتج فاسد/متعفن/يحتوي على مواد غريبة",
  退款原因_少件_含缺少配件_: "قطع قليلة (بما في ذلك الملحقات المفقودة)",
  退款原因_收到商品时有破损_污渍_变形:
    "كان المنتج تالفًا/ملطخًا/مشوهًا عند استلامه.",
  退款原因_假冒品牌: "العلامات التجارية المقلدة",
  退款原因_发票问题: "قضايا الفاتورة",
  退款原因_商家发错货: "أرسل التاجر البضائع الخطأ",
  退款原因_预约不到_商家不给退换:
    "لا يمكن تحديد موعد/لن يقوم التاجر بإرجاع المنتجات أو استبدالها",
  退款失败: "فشل استرداد الأموال",
  退款处理中: "جارٍ استرداد الأموال",
  默认: "تقصير",
  产品查询: "بحث منتوج",
  商店LOGO: "شعار المتجر",
  推广码: "شفرة الترقية",
  查看所有: "عرض الكل",
  确认收货成功: "تأكيد استلام البضائع بنجاح",
  物流公司: "شركة التخطيط والتنفيذ",
  物流单号: "رقم الشحنة",
  发货时间: "وقت الشحن",
  请先选择商品规格: "الرجاء تحديد مواصفات المنتج أولاً",
  个人信息: "معلومات شخصية",
  您的用户名: "اسم المستخدم الخاص بك",
  你的名字: "اسمك",
  登录名: "اسم المستخدم",
  你的邮件: "بريدك الالكتروني",
  你的密码: "كلمة السر خاصتك",
  重复输入密码: "اعد كلمة السر",
  店铺名称: "اسم المتجر",
  证书类型: "نوع الشهادة",
  身份证: "بطاقة التعريف",
  护照: "جواز سفر",
  驾驶执照: "رخصة السائق",
  社会保障卡: "بطاقة الضمان الاجتماعي",
  证书正面: "واجهة الشهادة",
  证书反面: "الجانب العكسي للشهادة",
  确认收货: "تأكيد استلام البضائع",
  请选择取消订单的原因必选: "الرجاء تحديد سبب إلغاء الطلب (مطلوب):",
  请选择申请退款的原因必选: "الرجاء تحديد سبب طلب استرداد الأموال (مطلوب):",
  留言: "رسالة",
  请输入留言: "من فضلك أدخل رسالة",
  没有帐户: "لا حساب",
  钱包充值: "إعادة شحن المحفظة",
  输入您的文字: "أدخل النص الخاص بك",
  商家登录: "تسجيل دخول التاجر",
  有关此产品的任何查询: "أي استفسار حول هذا المنتج",
  产品名称: "اسم المنتج",
  你的问题: "مشكلتك",
  白银店铺: "متجر الفضة",
  铂金店铺: "متجر البلاتين",
  钻石店铺: "متجر الماس",
  照片: "صورة",
  已退货: "عاد",
  邮寄状态: "الحالة البريدية",
  订单摘要: "ملخص الطلب",
  收件地址: "عنوان المستلم",
  订购日期: "تاريخ الطلب",
  订单状态: "حالة الطلب",
  总订单金额: "إجمالي مبلغ الطلب",
  邮寄方式: "طريقة البريد",
  附加信息: "معلومات إضافية",
  订单详细信息: "تفاصيل الطلب",
  交货类型: "نوع التوصيل",
  进行评论: "اكتب تعليق",
  已评论: "علق",
  订单金额: "كمية الطلب",
  优惠券: "قسيمة",
  统一运费: "رسوم شحن مسطحة",
  送货地址: "عنوان الشحن",
  评分: "نتيجة",
  你的意见: "رأيك",
  匿名: "مجهول",
  现金: "نقدي",
  详情: "تفاصيل",
  收货地址: "عنوان الشحن",
  暂时没有对话: "لا توجد محادثة بعد",
  你: "أنت",
  输入您的回复: "أدخل ردك",
  删除成功: "تم الحذف بنجاح",
  品牌: "ماركة",
  已缴纳的保证金: "تم دفع وديعة التأمين",
  黄金店铺: "متجر الذهب",
  没有更多数据: "لا مزيد من البيانات",
  站内信: "رسالة الموقع",
  系统通知: "إشعار النظام",
  邮箱: "بريد",
  手机号: "رقم التليفون",
  你的手机号: "رقم تليفونك",
  营业执照: "رخصة أعمال",
  你的邮箱: "صندوق البريد الخاص بك",
  搜索结果: "نتائج البحث",
  系统公告: "إشعار النظام",
  客服: "خدمة الزبائن",
  消息已撤回: "تم سحب الرسالة",
  物流详情: "التفاصيل اللوجستية",
  充值: "فوق حتى",
  提现: "ينسحب",
  信用分: "مستوى الرصيد",
  余额: "توازن",
  佣金: "عمولة",
  继续购物: "مواصلة التسوق",
  订单结算: "تسوية الطلب",
  加入对比: "أضف إلى المقارنة",
  佣金余额: "رصيد العمولة",
  刷新: "ينعش",
  刷新成功: "تم التحديث بنجاح",
  官网: "الموقع الرسمي",
  税号: "رقم التعريف الضريبي",
  订单: "طلب",
  合计: "المجموع",
  系统安全: "أمن النظام",
  Recharge_Money_Limit: "يجب أن يكون مبلغ إعادة الشحن بين {min} و{max}",
  限时优惠: "عرض لفترة محدودة",
  高价回收: "إعادة التدوير بأسعار مرتفعة",
  姓名: "اسم",
  商品订单号: "رقم طلب المنتج",
  商品在线回收: "إعادة تدوير المنتج عبر الإنترنت",
  提交: "يُقدِّم",
  回收记录: "سجلات إعادة التدوير",
  回收状态: "حالة إعادة التدوير",
  回收价格: "سعر إعادة التدوير",
  纳税码: "رمز الضريبة",
  买家登录: "تسجيل الدخول",
  买家注册: "يسجل",
  language: "阿拉伯语",
  助力提示:
    "يمكن للتجار أن تزيد من تعرض المنصة لمخازنهم ، وكلما ارتفع عدد الأيام التراكمية ، زاد التعرض.",
  已累计助力: "ساعد بشكل تراكمي",
  今日已助力: "وقد ساعد اليوم",
  立即助力: "مساعدة على الفور",
  商家助力: "مساعدة التاجر",
  证件号码: "رقم الهوية",
  证书号码: "رقم الشهادة"
};
